import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { ExpenseService } from '../../services/expense.service';
import { SharedExpenseGroup } from '../../interfaces/expense.interface';

declare const $: any;

@Component({
    selector: 'app-unified-viaticos-modal',
    templateUrl: './unified-viaticos-modal.component.html',
    styleUrls: ['./unified-viaticos-modal.component.scss']
})
export class UnifiedViaticosModalComponent {
    @Input() group: SharedExpenseGroup | null = null;
    @Output() groupDissolved = new EventEmitter<void>();

    isSeparating = false;
    private gridApi!: GridApi;

    columnDefs: ColDef[] = [
        { field: 'folio',               headerName: 'Folio',    width: 90  },
        { field: 'client',              headerName: 'Cliente',  width: 130 },
        { field: 'unit',                headerName: 'Unidad',   width: 110 },
        { field: 'driver_name',         headerName: 'Operador', flex: 1    },
        { field: 'origin_address',      headerName: 'Origen',   width: 140 },
        { field: 'destination_address', headerName: 'Destino',  width: 140 },
    ];

    defaultColDef: ColDef = {
        resizable: true,
        sortable: false,
        suppressMenu: true,
        cellStyle: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    };

    constructor(private expenseService: ExpenseService, private router: Router) {}

    open(): void {
        $('#unifiedViaticosModal').modal('show');
    }

    close(): void {
        $('#unifiedViaticosModal').modal('hide');
    }

    onGridReady(params: GridReadyEvent): void {
        this.gridApi = params.api;
    }

    onCellClicked(event: any): void {
        const row = event?.data;
        if (!row) return;
        const serviceData = { ...row, id: row.service_id };
        this.close();
        this.router.navigateByUrl('/service/detail', {
            state: { data: serviceData, status: [], address_service_id: null, next_address_service_id: null }
        });
    }

    get rowData() {
        return this.group?.services ?? [];
    }

    separate(): void {
        if (!this.group) return;
        this.isSeparating = true;
        this.expenseService.dissolveSharedGroup(this.group.group_id).subscribe({
            next: () => {
                this.isSeparating = false;
                this.close();
                this.groupDissolved.emit();
            },
            error: () => { this.isSeparating = false; }
        });
    }
}
